<div class="d-flex flex-column">
    <adapt-team-roles class="role-clarity px-3 bg-white rounded-2"
                      [team]="team"></adapt-team-roles>
</div>
